import React, { useState, useEffect, useRef, useContext } from 'react';
import '../../../assets/css/doctor/doctorauth/JoinAsDoctor.css';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import axios from 'axios';
import { AppContext } from '../../../context/AppContext';

const OAUTH_URLS = {
  google: 'https://accounts.google.com/o/oauth2/v2/auth?client_id=YOUR_GOOGLE_CLIENT_ID&redirect_uri=YOUR_REDIRECT_URI&response_type=code&scope=openid%20email%20profile',
  facebook: 'https://www.facebook.com/v18.0/dialog/oauth?client_id=YOUR_FB_APP_ID&redirect_uri=YOUR_REDIRECT_URI&scope=email,public_profile',
  linkedin: 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=YOUR_LINKEDIN_CLIENT_ID&redirect_uri=YOUR_REDIRECT_URI&scope=openid%20profile%20email',
};

export default function JoinAsDoctor({ isOpen, onClose }) {
  const [isLogin, setIsLogin] = useState(false);
  const [toast, setToast] = useState({ show: false, type: '', title: '', message: '' });
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { baseUrl, therapistLogin } = useContext(AppContext);
  const navigate = useNavigate();

  const timerRef = useRef(null);

  const showToast = (type, title, message) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ show: true, type, title, message });
    timerRef.current = setTimeout(() => {
      setToast(t => ({ ...t, show: false }));
      if (type === 'success') setTimeout(() => onClose(), 400);
    }, 3000);
  };

  const hideToast = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(t => ({ ...t, show: false }));
  };

  useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current); }, []);

  const handleOAuth = (provider) => {
    const url = OAUTH_URLS[provider];
    const w = 500, h = 600;
    const left = window.screenX + (window.outerWidth - w) / 2;
    const top = window.screenY + (window.outerHeight - h) / 2;
    window.open(url, `${provider}_oauth`, `width=${w},height=${h},left=${left},top=${top}`);
  };

  const doctorLogin = () => {
    if (!email || !password) {
      Swal.fire({
        icon: 'error',
        title: 'Fields Incomplete',
        text: 'Please enter both email and password.'
      });
      return;
    }
    setLoading(true);
    axios.post(`${baseUrl}/doctor/DoctorAuth/login`, {
      email: email,
      password: password
    })
      .then((response) => {
        // Context update — token, name save + KYC status fetch
        therapistLogin(response.data.token, response.data.therapist);
        setLoading(false);

        showToast(
          'success',
          'Welcome Back!',
          'You have successfully logged in to your dashboard.'
        );

        // KYC status ke hisaab se navigate
        setTimeout(() => {
          onClose();
          navigate('/doctor/Kyc');
        }, 1200);

        console.log(response.data);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: error?.response?.data?.message || 'Invalid email or password.'
        });
        console.log(error);
      });
  };

  const doctorRegister = () => {
    if (!fullName || !email || !password || !confirmPassword) {
      Swal.fire({
        icon: 'warning',
        title: 'Fields Incomplete',
        text: 'Please complete all required fields.'
      });
      return;
    }
    if (password !== confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Password Mismatch',
        text: 'Passwords do not match.'
      });
      return;
    }
    setLoading(true);
    axios.post(`${baseUrl}/doctor/DoctorAuth/register`, {
      full_name: fullName, email, password, confirmpassword: confirmPassword
    })
      .then((response) => {
        // Context update — token, name save + KYC status fetch (naya account => not_submitted)
        therapistLogin(response.data.token, response.data.therapist);
        setLoading(false);

        Swal.fire({
          icon: 'success',
          title: 'Account Created!',
          text: `Welcome ${fullName}! Let's complete your KYC.`,
          confirmButtonText: 'Continue'
        }).then(() => {
          onClose();
          navigate('/doctor/Kyc');
        });

        console.log(response.data);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Registration Failed',
          text: error?.response?.data?.message || 'Something went wrong. Please try again.'
        });
        console.log(error);
      });
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Font Awesome 6 CDN */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
      />

      {/* Toast */}
      <div className={`doctor-toast ${toast.type} ${toast.show ? 'show' : ''}`}>
        <span className="doctor-toast-icon">
          {toast.type === 'success' ? '✅' : '⚠️'}
        </span>
        <div className="doctor-toast-body">
          <div className="doctor-toast-title">{toast.title}</div>
          <div className="doctor-toast-msg">{toast.message}</div>
        </div>
        <button className="doctor-toast-close" onClick={hideToast}>×</button>
      </div>

      {/* Modal */}
      <div className="doctor-modal-overlay" onClick={onClose}>
        <div onClick={(e) => e.stopPropagation()} className="doctor-modal-content">

          <button onClick={onClose} className="doctor-close-button">×</button>

          <div className={`doctor-modal-container ${isLogin ? 'login-mode' : 'signup-mode'}`}>

            {/* Form Section */}
            <div className="doctor-form-section">
              <div className="doctor-form-header">
                <div className="doctor-form-logo">
                  <i className="fa-solid fa-stethoscope"></i> Therapist Portal
                </div>
              </div>

              <h2 className="doctor-form-title">
                {isLogin ? 'Therapist Login' : 'Therapist Registration'}
              </h2>
              <p className="doctor-form-subtitle">
                {isLogin ? 'Access your medical dashboard' : 'Create your therapist account'}
              </p>

              <div className="doctor-social-buttons-row">
                <button className="doctor-social-button" onClick={() => handleOAuth('google')}>
                  <i className="fa-brands fa-google"></i> Google
                </button>
              </div>

              <div className="doctor-divider-container">
                <span className="doctor-divider-text">or use your email</span>
              </div>

              <div className="doctor-form-fields">
                {!isLogin && (
                  <div className="doctor-input-group">
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Full Name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      className="doctor-form-input"
                    />
                    <span className="doctor-input-icon">👨‍⚕️</span>
                  </div>
                )}
                <div className="doctor-input-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="doctor-form-input"
                  />
                  <span className="doctor-input-icon">📧</span>
                </div>
                <div className={`doctor-input-group ${isLogin ? 'password-login' : ''}`}>
                  <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="doctor-form-input"
                  />
                  <span className="doctor-input-icon">🔒</span>
                </div>
                {!isLogin && (
                  <div className="doctor-input-group">
                    <input
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="doctor-form-input"
                    />
                    <span className="doctor-input-icon">🔐</span>
                  </div>
                )}
                {isLogin && (
                  <div className="doctor-forgot-password">
                    <a href="#" className="doctor-forgot-link">Forgot Password?</a>
                  </div>
                )}
                <button
                  onClick={isLogin ? doctorLogin : doctorRegister}
                  className="doctor-submit-button"
                  disabled={loading}
                >
                  {loading ? 'Please wait...' : isLogin ? 'Login to Dashboard' : 'Create Doctor Account'}
                </button>
                {!isLogin && (
                  <p className="doctor-terms-text">
                    By registering, you agree to our Terms of Service and Privacy Policy
                  </p>
                )}
              </div>
            </div>

            {/* Welcome Section */}
            <div className="doctor-welcome-section">
              <div className="doctor-welcome-circle doctor-welcome-circle-1" />
              <div className="doctor-welcome-circle doctor-welcome-circle-2" />

              <div className="doctor-welcome-icon">
                <i className="fa-solid fa-user-doctor"></i>
              </div>

              <h2 className="doctor-welcome-title">
                {isLogin ? 'Welcome Back Doctor!' : 'Join Our Network!'}
              </h2>

              <div className="doctor-welcome-body">
                <p className="doctor-welcome-text">
                  {isLogin
                    ? 'Access your patient records, appointments, and medical dashboard'
                    : 'Register to connect with patients and manage your medical practice online'}
                </p>

                <button onClick={() => setIsLogin(!isLogin)} className="doctor-toggle-button">
                  {isLogin ? 'Register Now' : 'Already Registered?'}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}